import { ActionType } from '../../types';

export const TimelineExportActions = {
    timelineExportStarted: () =>
        ({
            type: 'TimelineExport/Load/Started',
        } as const),

    timelineExportSucceeded: (url: string) =>
        ({
            type: 'TimelineExport/Load/Succeeded',
            payload: { url },
        } as const),

    timelineExportFailed: () =>
        ({
            type: 'TimelineExport/Load/Failed',
        } as const),

    timelineExportUnmounted: () =>
        ({
            type: 'TimelineExport/Load/Unmounted',
        } as const),
};

export type TimelineExportActions = ActionType<typeof TimelineExportActions>;
